module.exports = __webpack_public_path__ + "media/img/flags/fr-8f79738a3d13c4350ecb972d38425667.svg";